/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/db/index */
import{default as e}from"./StorageProvider.mjs";export*from"./interface.mjs";export{e as StorageProvider};
//# sourceMappingURL=index.mjs.map